export default __webpack_public_path__ + "static/media/webinvictusmobile.45e732b0.webp";